<template>
  <div class="dougong-pay-config">
    <el-alert
      type="info"
      :closable="false"
      show-icon
      class="config-tip"
      title="线上、线下支付能力需在汇付斗拱后台分别开通"
    />
    <el-form ref="form" :model="form" :rules="rules" label-width="140px">
      <el-form-item label="HuifuId" prop="huifu_id">
        <el-input
          v-model="form.huifu_id"
          style="width: 450px"
          placeholder="汇付商户号（data.huifu_id）"
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" :loading="saving" @click="saveConfig">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getDougongDetail, saveDougongFrom } from '@/api/trade'

const DEFAULT_PRODUCT_ID = 'PAYUN'

export default {
  name: 'DougongPayConfig',
  props: {
    dealerId: {
      type: [String, Number],
      required: true
    },
    dealerName: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      saving: false,
      form: {
        dealer_id: '',
        huifu_id: '',
        product_id: DEFAULT_PRODUCT_ID
      },
      rules: {
        huifu_id: [{ required: true, message: '请输入 HuifuId', trigger: 'blur' }]
      }
    }
  },
  mounted () {
    this.form.dealer_id = this.dealerId
    this.loadConfig()
  },
  watch: {
    dealerId () {
      this.form.dealer_id = this.dealerId
      this.loadConfig()
    }
  },
  methods: {
    loadConfig () {
      getDougongDetail({ dealer_id: this.dealerId }).then(res => {
        const data = res.data.data || {}
        this.form.huifu_id = data.huifu_id || data.sys_id || ''
        this.form.product_id = (data.product_id || '').trim() || DEFAULT_PRODUCT_ID
      }).catch(() => {})
    },
    saveConfig () {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        saveDougongFrom({
          dealer_id: this.dealerId,
          huifu_id: this.form.huifu_id,
          product_id: this.form.product_id || DEFAULT_PRODUCT_ID
        })
          .then(res => {
            this.$message.success(res.data.message || '保存成功')
          })
          .catch(err => {
            const msg = (err.response && err.response.data && err.response.data.message)
              || err.message
              || '保存失败'
            this.$message.error(msg)
          })
          .finally(() => {
            this.saving = false
          })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.dougong-pay-config {
  padding: 0 20px 20px;

  .config-tip {
    margin-bottom: 16px;
  }
}
</style>
